import mondaySdk from "monday-sdk-js";
import { MondayClientSdk } from "monday-sdk-js/types/client-sdk.interface";
import { useState } from "react";

// Usage of mondaySDK example, for more information visit here: https://developer.monday.com/apps/docs/introduction-to-the-sdk/
export function useMondaySdk() {
  const [monday,] = useState<MondayClientSdk>(mondaySdk());
  return monday;
}
